import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import MessagePanel from '../../common/components/MessagePanel/MessagePanel';
import { Provider } from '../../config';
import FlowMode from '../../providers/validation/FlowMode';
import { ValidationContext } from '../../providers/ValidationContext';
import { FlowConfigContext } from '../../providers/FlowConfigContext';
import withRouteAnalytics from '../../services/analytics/withRouteAnalytics';
import { Screens } from '../../services/analytics/screens';
import { GatekeeperNetworkServiceContext } from '../../providers/GatekeeperNetworkService/GatekeeperNetworkServiceContext';

function ValidationErrorScreen(): JSX.Element {
  const { flowFailed } = useContext(FlowConfigContext);
  const { flowMode } = useContext(ValidationContext);
  const { state } = useLocation();
  const { getExternalLinksConfig } = useContext(FlowConfigContext);
  const { gknServiceData } = useContext(GatekeeperNetworkServiceContext);
  const { civicSupportLink, civicSupportIpMismatchLink } = getExternalLinksConfig();
  const [title, setTitle] = useState('screens.documentPass.error.title');
  const [description, setDescription] = useState('screens.documentPass.error.description');
  const [bottomDescription, setBottomDescription] = useState<string | undefined>(
    'screens.documentPass.error.bottomDescription',
  );
  const [supportLink, setSupportLink] = useState<string>(civicSupportLink);
  const [buttonLabel, setButtonLabel] = useState<string | undefined>('screens.documentPass.error.buttonLabel');
  const handleConfirm = () => {
    flowFailed({ provider: Provider.WEB });
  };

  useEffect(() => {
    if (flowMode !== FlowMode.partial) {
      return;
    }

    switch (state?.error?.message.toLowerCase()) {
      case 'token is expired': {
        setTitle('screens.documentPass.error.title_token_expired');
        if ((gknServiceData?.constraints?.public?.proofOfPersonhood?.enableHandoverBreakoutFlow ?? false) === true) {
          setDescription('screens.documentPass.error.description_token_expired_breakout_mode');
        } else {
          setDescription('screens.documentPass.error.description_token_expired');
        }
        setBottomDescription(undefined);
        setButtonLabel(undefined);
        break;
      }
      case 'invalid ip address': {
        setTitle('screens.documentPass.error.title_ip_mistmatch');
        setDescription('screens.documentPass.error.description_ip_mistmatch');
        setBottomDescription(undefined);
        setButtonLabel(undefined);
        setSupportLink(civicSupportIpMismatchLink);
        break;
      }
      default: {
        if ((gknServiceData?.constraints?.public?.proofOfPersonhood?.enableHandoverBreakoutFlow ?? false) === true) {
          setTitle('screens.documentPass.error.title_partial_breakout_mode');
          setDescription('screens.documentPass.error.description_partial_breakout_mode');
        } else {
          setTitle('screens.documentPass.error.title_partial');
          setDescription('screens.documentPass.error.description_partial');
        }
        setBottomDescription(undefined);
        setButtonLabel(undefined);
      }
    }
  }, [flowMode]);

  return (
    <MessagePanel
      title={title}
      description={description}
      bottomDescription={bottomDescription}
      dataTestId="DOCUMENT_ERROR_SCREEN"
      buttonLabel={buttonLabel}
      onConfirm={handleConfirm}
      showUserInfo
      showSupportLink
      supportLink={supportLink}
    />
  );
}
export default withRouteAnalytics(ValidationErrorScreen, Screens.UNEXPECTED_ERROR);
